import React from "react";
import { ENGINE_COMPONENT_TYPES } from "../../constants";
import Accordion from "./Accordion";
import Background from "./Background";

const GeneralSettingTab = ({ componentConfig }) => {
  const panelList = componentConfig?.components.map((component) => {
    let renderComp = null;
    switch (component.type) {
      case ENGINE_COMPONENT_TYPES.BACKGROUND_COLOR: {
        renderComp = (
          <Background
            currentConfig={component.getCurrentConfig()}
            changeBackgroundColor={component.changeBackgroundColor}
            updateConfig={component.updateConfig}
          />
        );
        break;
      }
      default:
        renderComp = null;
    }
    return {
      header: component.title,
      headerClass: "light-accordion-header",
      component: renderComp,
    };
  });

  return (
    <div className="lightSettingContainer">
      <Accordion className="light-accordion" panelList={panelList} />
    </div>
  );
};

export default GeneralSettingTab;
